export const ellipsizeUrl = (url: string, maxLength: number = 50) => {
  if (url.length <= maxLength) {
    return url;
  }

  const [protocolAndDomain, ...pathParts] = url.split("/");
  const domain = protocolAndDomain.includes("://")
    ? protocolAndDomain.split("://")[1]
    : protocolAndDomain;

  const path = pathParts.join("/");

  const ellipsizeLength = maxLength - domain.length - 5;
  const firstPartLength = Math.ceil(ellipsizeLength / 2);
  const lastPartLength = Math.floor(ellipsizeLength / 2);

  const start = path.slice(0, firstPartLength);
  const end = path.slice(-lastPartLength);

  return `${domain}/.../${start}${end}`;
};
